import { Injectable } from '@angular/core';
import { captureException } from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class AssetsPerformanceMonitoringService {
  slowAssetIgnoreList = [
    'https://sentry.mindplay.com/',
    'https://accounts.google.com'
  ];


  init() {
    if (!('PerformanceObserver' in window)) {
      console.warn('PerformanceObserver not supported in this browser');
      return;
    }

    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries() as PerformanceResourceTiming[];

      entries.forEach((entry) => {
        const duration = entry.duration;

        // Skip when duration unknown (cross-origin and missing Timing-Allow-Origin)
        if (!duration || duration === 0) return;

        // Skip for api calls, api is being tracked in error interceptor
        if (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest") {
          return;
        }

        // Evaluate thresholds
        this.checkSlowAsset(entry, duration, false);
      });
    });

    observer.observe({ entryTypes: ['resource'] });
  }

  checkSlowAsset(entry: PerformanceResourceTiming, duration: number, isError: boolean) {
    if (duration > 5000) {
      const isInIgnoreList = this.slowAssetIgnoreList.some(url => entry.name.includes(url));
      if (isInIgnoreList) {
        return;
      }

      const ex = new Error(`Slow Asset (ERROR > 5s): ${entry.initiatorType} ${entry.name} - ${duration.toFixed(0)}ms`);
      captureException(ex, {
        level: 'error',
        tags: {
          url: entry.name,
          initiatorType: entry.initiatorType,
          duration: duration.toFixed(0),
          type: 'slow-asset',
          status: isError ? 'error' : 'success',
        }
      });
    }
  }
}
